import { Component, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as moment from 'moment';
import { FieldValueChangedArgs } from '@app/layout/field-value-changed-args';

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.less'],
})
export class InputDateComponent extends Field implements OnInit {
  dateFormat = g.companyConfiguration.DateFormat;
  global = g;

  disabledDatesArr: any[] = [];
  daysLine: any = {};
  AllowedStartDate: string;
  AllowedEndDate: string;

  notLoading = false;
  isLoading1st = true;
  isLoading2nd = true;
  allowClearDate = g.allowClearDate;

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  disabledDate = (current: Date): boolean => this.isDisabledDate(current);

  isDisabledDate(current: Date): boolean {
    if (
      this.disabledDatesArr.length == 0 &&
      (this.AllowedStartDate == null ||
        this.AllowedStartDate === undefined ||
        this.AllowedStartDate === '') &&
      (this.AllowedEndDate == null ||
        this.AllowedEndDate === undefined ||
        this.AllowedEndDate === '')
    ) {
      return false;
    }

    if (
      this.daysLine == null &&
      (this.AllowedStartDate == null ||
        this.AllowedStartDate === undefined ||
        this.AllowedStartDate === '') &&
      (this.AllowedEndDate == null ||
        this.AllowedEndDate === undefined ||
        this.AllowedEndDate === '')
    ) {
      return false;
    }

    let days = current.getDay();
    let isDisabled = false;

    isDisabled =
      this.daysLine != null &&
      ((days === 1 && this.daysLine.MON == 'N') ||
        (days === 2 && this.daysLine.TUE == 'N') ||
        (days === 3 && this.daysLine.WED == 'N') ||
        (days === 4 && this.daysLine.THU == 'N') ||
        (days === 5 && this.daysLine.FRI == 'N') ||
        (days === 6 && this.daysLine.SAT == 'N') ||
        (days === 0 && this.daysLine.SUN == 'N'));

    if (!isDisabled) {
      const dateFormatted = moment(current).format(
        this.global.companyConfiguration.MomentDateFormat
      );
      this.disabledDatesArr
        .filter((d) => d.Type === 'H')
        .forEach((element) => {
          let strDate = element.StrDate;
          //let date = moment(strDate, this.global.companyConfiguration.MomentDateFormat).toDate();
          if (dateFormatted === strDate) {
            isDisabled = true;
            //console.log(date);
            //console.log(current);
          }
        });
    }
    if (!isDisabled) {
      if (
        this.AllowedStartDate != null &&
        this.AllowedStartDate !== undefined &&
        this.AllowedStartDate !== '' &&
        this.AllowedEndDate != null &&
        this.AllowedEndDate !== undefined &&
        this.AllowedEndDate !== ''
      ) {
        let startDate = moment(
          this.AllowedStartDate,
          this.global.companyConfiguration.MomentDateFormat
        ).toDate();
        let endDate = moment(
          this.AllowedEndDate,
          this.global.companyConfiguration.MomentDateFormat
        ).toDate();
        isDisabled = !(current >= startDate && current <= endDate);
      } else if (
        this.AllowedStartDate != null &&
        this.AllowedStartDate !== undefined &&
        this.AllowedStartDate !== '' &&
        (this.AllowedEndDate == null ||
          this.AllowedEndDate === undefined ||
          this.AllowedEndDate === '')
      ) {
        let startDate = moment(
          this.AllowedStartDate,
          this.global.companyConfiguration.MomentDateFormat
        ).toDate();
        isDisabled = !(current >= startDate);
      } else if (
        (this.AllowedStartDate == null ||
          this.AllowedStartDate === undefined ||
          this.AllowedStartDate === '') &&
        this.AllowedEndDate != null &&
        this.AllowedEndDate !== undefined &&
        this.AllowedEndDate !== ''
      ) {
        let endDate = moment(
          this.AllowedEndDate,
          this.global.companyConfiguration.MomentDateFormat
        ).toDate();
        isDisabled = !(current <= endDate);
      }
    }

    return isDisabled;
  }

  ngOnInit(): void {
    console.log('ngOnInit: filterfields');
    //console.log(this.customerCode);
    this.notLoading = false;
    this.isLoading1st = true;
    this.isLoading2nd = true;
    if (
      this.field.AdditionalInformationParsed.DisabledDatesSQLStatementId !=
        null &&
      this.field.AdditionalInformationParsed.DisabledDatesSQLStatementId !=
        undefined &&
      this.field.AdditionalInformationParsed.DisabledDatesSQLStatementId != 0
    ) {
      this.layoutService
        .executeQuery(
          this.field.AdditionalInformationParsed.DisabledDatesSQLStatementId,
          {}
        )
        .subscribe((result: any[]) => {
          this.disabledDatesArr = result;
          if (this.disabledDatesArr.length !== 0) {
            this.daysLine = this.disabledDatesArr.find((d) => d.Type === 'D');
          }

          this.isLoading1st = false;
          this.notLoading = !this.isLoading1st && !this.isLoading2nd;
        });
    } else {
      this.isLoading1st = false;
      this.notLoading = !this.isLoading1st && !this.isLoading2nd;
    }

    if (
      this.field.AdditionalInformationParsed.AllowedDatesRangeSQLStatementId !=
        null &&
      this.field.AdditionalInformationParsed.AllowedDatesRangeSQLStatementId !=
        undefined &&
      this.field.AdditionalInformationParsed.AllowedDatesRangeSQLStatementId !=
        0
    ) {
      this.layoutService
        .executeQuery(
          this.field.AdditionalInformationParsed
            .AllowedDatesRangeSQLStatementId,
          {}
        )
        .subscribe((result: any[]) => {
          this.AllowedStartDate = result[0].STARTDATE;
          this.AllowedEndDate = result[0].ENDDATE;

          this.isLoading2nd = false;
          this.notLoading = !this.isLoading1st && !this.isLoading2nd;
        });
    } else {
      this.isLoading2nd = false;
      this.notLoading = !this.isLoading1st && !this.isLoading2nd;
    }
    super.ngOnInit();
  }

  onOpenChange() {
    const args: FieldValueChangedArgs = {
      recordModel: this.recordModel,
      recordProperty: this.recordProperty,
      line: this.lineId,
      moduleStructure: this.moduleStructure,
      sectionTagName: this.sectionTagName,
      token: g.getToken(),
      formId: '',
    };

    console.log('OnDatePickerOpen');
    const customEvent = new CustomEvent('OnDatePickerOpen', {
      detail: args,
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);
  }

  dateValueChanged() {
    // if (
    //   this.recordProperty.ValueAsObject === null ||
    //   this.recordProperty.ValueAsObject === undefined
    // ) {
    //   this.recordProperty.Value = '';
    // } else {
    //   console.log('Date Value: ', this.recordProperty.ValueAsObject);
    //   this.recordProperty.ValueAsObject = moment(this.recordProperty.ValueAsObject).format('yyyy-MM-dd');
    // }

    this.valueChanged();
  }
}
